import React, { Fragment, useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import Checkbox from '@tds/core-checkbox';

import { FieldWrapper } from './css';
import Note from '../../note';

const FieldMultiCheckbox = ({ data }) => {
  const {
    ref,
    name,
    label,
    options,
    required,
    onChange,
    note,
    readonly,
    formFields,
    value: fieldValue,
    isShowNoteBackground
  } = data;
  const updateFieldValue =
    typeof fieldValue === 'string' ? fieldValue.split(',') : fieldValue;
  const mappedValues =
    fieldValue &&
    updateFieldValue.reduce((ac, a) => ({ ...ac, [a]: true }), {});
  const mappedOptions = options.map(op => ({
    ...op,
    checked: (mappedValues && mappedValues[op.fields.value] && true) || false
  }));
  const [allOptions, setAllOptions] = useState(mappedOptions);

  useEffect(() => {
    if (JSON.stringify(allOptions) !== JSON.stringify(mappedOptions))
      setAllOptions(mappedOptions);
  }, [mappedOptions]);

  const onCheckboxChange = ({ target: { value, name: evtName, checked } }) => {
    const option = allOptions.find(op => op.fields.value === value);
    option.checked = checked;
    const updatedValue = allOptions
      .filter(op => op.checked)
      .map(op => op.fields.value);
    const event = {
      target: { name: evtName, value: updatedValue }
    };
    return onChange && onChange(event);
  };

  return (
    <FieldWrapper>
      <p className="frg-body-font-14px">
        {label}
        {required && `*`}
      </p>
      {note && note.content && (
        <Note
          type="richText"
          data={note}
          isShowNoteBackground={isShowNoteBackground}
        />
      )}
      <div>
        {allOptions.map(item => {
          const {
            fields: { label: itemLabel, value, disabledOption },
            checked
          } = item;
          const LabelLogic =
            formFields && formFields.telusOptikTvComments
              ? itemLabel.split('($')[0]
              : itemLabel;
          const id = `${name}${itemLabel}`;
          return (
            <Fragment key={id}>
              <Checkbox
                name={name}
                ref={ref}
                checked={checked}
                value={value}
                onChange={onCheckboxChange}
                disabled={readonly || disabledOption}
                label={LabelLogic || ''}
              />
            </Fragment>
          );
        })}
      </div>
    </FieldWrapper>
  );
};

FieldMultiCheckbox.propTypes = {
  data: PropTypes.shape({
    ref: PropTypes.object,
    name: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    required: PropTypes.bool,
    note: PropTypes.shape({
      content: PropTypes.arrayOf(PropTypes.object)
    }),
    readonly: PropTypes.bool,
    value: PropTypes.string,
    onChange: PropTypes.func.isRequired,
    options: PropTypes.arrayOf(
      PropTypes.shape({
        value: PropTypes.string.isRequired,
        label: PropTypes.string
      })
    ).isRequired
  }).isRequired
};

export default FieldMultiCheckbox;
